import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PaginationContainer, PaginationInfo } from "./Components";
import { faChevronRight, faChevronLeft, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "../../helper";
import { useDataTable } from "../../hooks/useDataTable";
import { useTranslation } from "react-i18next";
const Pagination = () => {
    const { t } = useTranslation();
    const { changePage, currentPage, totalPage, totalRow, from, to } = useDataTable();

    const onPrev = () => currentPage > 1 && changePage(currentPage - 1);
    const onNext = () => currentPage < totalPage && changePage(currentPage + 1);
    const onLast = () => currentPage < totalPage && changePage(totalPage);
    const onFirst = () => currentPage > 1 && changePage(1);

    const renderPages = () => {
        if (totalPage <= 8) {
        return Array.from({ length: totalPage }, (_, i) => (
            <li
                key={i}
                className={currentPage === i + 1 ? "active" : ""}
                onClick={() => changePage(i + 1)}
            >
            {i + 1}
            </li>
        ));
        }

        let pages = [];
        pages.push(
        <li
            key={1}
            className={currentPage === 1 ? "active" : ""}
            onClick={() => changePage(1)}
        >
            1
        </li>
        );

        if (currentPage > 4) {
            pages.push(<li key="left-ellipsis" className="dots">...</li>);
        }

        let start = Math.max(2, currentPage - 2);
        let end = Math.min(totalPage - 1, currentPage + 2);

        for (let i = start; i <= end; i++) {
            pages.push(
                <li
                    key={i}
                    className={currentPage === i ? "active" : ""}
                    onClick={() => changePage(i)}
                >
                {i}
                </li>
            );
        }

        if (currentPage < totalPage - 3) {
            pages.push(<li key="right-ellipsis" className="dots">...</li>);
        }

        pages.push(
        <li
            key={totalPage}
            className={currentPage === totalPage ? "active" : ""}
            onClick={() => changePage(totalPage)}
        >
            {totalPage}
        </li>
        );

        return pages;
    };

    return (
        <PaginationContainer>
            <PaginationInfo>
                {t("Showing {{from}} to {{to}} of {{totalRow}} entries", {
                from,
                to,
                totalRow,
                })}
            </PaginationInfo>
            <ul>
                <li
                    className={classNames([currentPage <= 1 && "disabled", "first-end"])}
                    onClick={onFirst}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                    <FontAwesomeIcon icon={faChevronLeft} />
                </li>
                <li
                    className={currentPage <= 1 ? "disabled" : ""}
                    onClick={onPrev}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </li>

                {renderPages()}

                <li
                    className={currentPage >= totalPage ? "disabled" : ""}
                    onClick={onNext}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </li>
                <li
                    className={classNames([currentPage >= totalPage && "disabled", "first-end"])}
                    onClick={onLast}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faChevronRight} />
                </li>
            </ul>
        </PaginationContainer>
    );
}
export default Pagination;